module.exports = __webpack_public_path__ + "static/couture-a54db2224a62059b053953c853d6e993.png";